if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    connectedCallback() {
      // 直接添加滚动监听
      window.addEventListener('scroll', () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const viewportHeight = window.innerHeight;
        
        // 滚动到 100vh 时切换类
        if (scrollTop >= viewportHeight) {
          this.classList.add('back-to-top--in');
        } else {
          this.classList.remove('back-to-top--in');
        }
      }, { passive: true });
      
      // 初始检查
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const viewportHeight = window.innerHeight;
      if (scrollTop >= viewportHeight) {
        this.classList.add('back-to-top--in');
      }
    }
  }

  customElements.define('back-to-top', BackToTop);
}